<template>
  <li>
    <div class="tariff-period">
      {{ term.title }}
      <span class="age-group">{{ customerGroup.title }}</span>
    </div>
    <div class="price">
      {{ $n(configuration.price.amount, 'currency') }}
      <span v-if="amountSaved > 0" class="period-discount">{{ $t('generic.bespaar') }} {{ $n(amountSaved, 'currency') }}</span>
    </div>
  </li>
</template>

<script>

import ProductConfiguration from '../../types/product-configuration'

export default {

  props: {
    configuration: {
      type: ProductConfiguration | Object,
      default: null
    }
  },
  computed: {
    term: function () {
      return this.$store.state.selection.availableFilterEntities.terms.find((term) => term.id === this.configuration.term.id)
    },
    customerGroup: function () {
      return this.$store.state.selection.availableFilterEntities.customerGroups.find((group) => group.id === this.configuration.customerGroup.id)
    },
    product: function () {
      return this.$store.state.selection.availableFilterEntities.products.find((product) => product.id === this.configuration.product.id)
    },
    amountSaved: function () {
      const mostExpensiveConfiguration = this.$store.getters['selection/mostExpensiveConfigurationByProductAndCustomerGroup'](this.product, this.customerGroup)
      const amountSavedPerYear = mostExpensiveConfiguration.pricePerYear.amount - this.configuration.pricePerYear.amount

      return this.term.termsPerYear > 0 ? amountSavedPerYear / this.term.termsPerYear : 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product-overview/ProductConfiguration.vue